module.exports = __webpack_public_path__ + "static/media/projectsImg.7f1d3df7.png";